"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfTypeformPayloadDto = instanceOfTypeformPayloadDto;
exports.TypeformPayloadDtoFromJSON = TypeformPayloadDtoFromJSON;
exports.TypeformPayloadDtoFromJSONTyped = TypeformPayloadDtoFromJSONTyped;
exports.TypeformPayloadDtoToJSON = TypeformPayloadDtoToJSON;
exports.TypeformPayloadDtoToJSONTyped = TypeformPayloadDtoToJSONTyped;
const FormResponse_1 = require("./FormResponse");
/**
 * Check if a given object implements the TypeformPayloadDto interface.
 */
function instanceOfTypeformPayloadDto(value) {
    if (!('eventId' in value) || value['eventId'] === undefined)
        return false;
    if (!('formResponse' in value) || value['formResponse'] === undefined)
        return false;
    return true;
}
function TypeformPayloadDtoFromJSON(json) {
    return TypeformPayloadDtoFromJSONTyped(json, false);
}
function TypeformPayloadDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'eventId': json['event_id'],
        'formResponse': (0, FormResponse_1.FormResponseFromJSON)(json['form_response']),
    };
}
function TypeformPayloadDtoToJSON(json) {
    return TypeformPayloadDtoToJSONTyped(json, false);
}
function TypeformPayloadDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'event_id': value['eventId'],
        'form_response': (0, FormResponse_1.FormResponseToJSON)(value['formResponse']),
    };
}
//# sourceMappingURL=TypeformPayloadDto.js.map